import { AuthPageLayout } from "@/components/auth-page-layout";
import { NewUserSetupForm } from "@/components/new-user-setup-form";
import i18n from "@/i18n";
import {
  applyLanguageFromSearch,
  parseLangSearchParam,
} from "@/lib/app-language";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/new-user-setup")({
  validateSearch: (search: Record<string, unknown>) => {
    const token = typeof search.token === "string" ? search.token : "";
    return { token, lang: parseLangSearchParam(search) };
  },
  beforeLoad: ({ search }) => {
    applyLanguageFromSearch(i18n, search.lang);
  },
  component: NewUserSetupPage,
});

export default function NewUserSetupPage() {
  const { token } = Route.useSearch();

  return (
    <AuthPageLayout>
      <NewUserSetupForm token={token} />
    </AuthPageLayout>
  );
}
